module.exports = __webpack_public_path__ + "img/20.e1c9b665.webp";